import React from "react";
import { useTitle } from "react-use";
import { LayoutVideoWall } from "../components/LayoutVideoWall";
import VideoWall from "../components/video-wall/VideoWall";
import { VideoWallProvider } from "../context/VideoWallContext";
import { useSetLogoStyle } from "../hooks/useSetLogoStyle";

export const CinemaRoom: React.FC = () => {
  useSetLogoStyle("light");

  useTitle("Cinema Room | Boots Exhibition");

  return (
    <VideoWallProvider>
      <LayoutVideoWall>
        <VideoWall />
      </LayoutVideoWall>
    </VideoWallProvider>
  );
};
